import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Message} from '@aperza/ui';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

const FormRowHorizontal = (props) => {

  let {
    rowNameId,
    required,
    readOnly,
    value,
    children,
  } = props;

  return (
    <div className="d-flex flex-row align-items-center aw-form-horizontal-field">
      {rowNameId && !readOnly &&
      <div className={'aw-form-horizontal-field-label'}>
        <Message messageId={rowNameId}/>
      </div>
      }
      <div className="d-flex flex-column">
        {children}
      </div>
    </div>
  )

}

FormRowHorizontal.propTypes = {
  rowNameId: PropTypes.string.isRequired,
  required: PropTypes.bool,
};

export default FormRowHorizontal;
